export default "__VITE_ASSET__j_7f_u7c__"